export default {
  checkInterval: 'интервалПроверки',
  newCommitCheckInterval: 'Интервал проверки новых коммитов',
  schedule: 'Расписание',
  newSchedule: 'Новое расписание',
  deleteSchedule: 'Удалить расписание',
  editSchedule: 'Редактировать расписание',
  backup: 'Резервное копирование проекта',
  downloadTheProjectBackupFile: 'Скачать файл резервной копии проекта.',
  restoreProject: 'Восстановить проект...',
  incorrectUsrPwd: 'Неверный логин или пароль',
  askDeleteUser: 'Вы действительно хотите удалить этого пользователя?',
  askDeleteTemp: 'Вы действительно хотите удалить этот шаблон?',
  askDeleteEnv: 'Вы действительно хотите удалить эту среду?',
  askDeleteInv: 'Вы действительно хотите удалить этот инвентарь?',
  askDeleteKey: 'Вы действительно хотите удалить этот ключ?',
  askDeleteRepo: 'Вы действительно хотите удалить этот репозиторий?',
  askDeleteProj: 'Вы действительно хотите удалить этот проект?',
  askDeleteTMem: 'Вы действительно хотите удалить этого участника команды?',
  askDeleteSchedule: 'Вы действительно хотите удалить это расписание?',
  edit: 'Редактировать',
  nnew: 'Новый',
  keyFormSshKey: 'SSH ключ',
  keyFormLoginPassword: 'Логин с паролем',
  keyFormNone: 'Нет',
  incorrectUrl: 'Неверный URL',
  username: 'Имя пользователя',
  username_required: 'Имя пользователя обязательно',
  dashboard: 'Панель управления',
  history: 'История',
  activity: 'Активность',
  settings: 'Настройки',
  signIn: 'Войти',
  password: 'Пароль',
  changePassword: 'Сменить пароль',
  editUser: 'Редактировать пользователя',
  newProject: 'Новый проект',
  close: 'Закрыть',
  newProject2: 'Новый проект...',
  demoMode: 'РЕЖИМ ДЕМО',
  task: 'Задача #{expr}',
  youCanRunAnyTasks: 'Вы можете запускать любые задачи',
  youHaveReadonlyAccess: 'У вас доступ только для чтения',
  taskTemplates: 'Шаблоны задач',
  inventory: 'Инвентарь',
  environment: 'Группы переменных',
  keyStore: 'Хранилище ключей',
  repositories: 'Репозитории',
  darkMode: 'Темный режим',
  team: 'Команда',
  users: 'Пользователи',
  editAccount: 'Редактировать аккаунт',
  signOut: 'Выйти',
  error: 'Ошибка',
  refreshPage: 'Обновить страницу',
  relogin: 'Повторный вход',
  howToFixSigninIssues: 'Как исправить проблемы с входом',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Понадобится shell-доступ к серверу, на котором запущен ZetaPilot.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Выполните следующую команду на сервере, чтобы увидеть существующих пользователей:',
  semaphoreUserList: 'semaphore user list',
  youCanChangePasswordOfExistingUser: 'Вы можете изменить пароль существующего пользователя:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore user change-by-login --login user123 --password {makePasswordExample}',
  orCreateNewAdminUser: 'Или создайте нового администратора:',
  close2: 'Закрыть',
  semaphore: 'ZETAPILOT',
  brandClassifier: 'ОРКЕСТРАТОР',
  currentProject: 'Текущий проект',
  projectNavigation: 'Навигация проекта',
  navGroupOperations: 'Операции',
  navGroupRuntime: 'Среда запуска',
  navGroupAccess: 'Доступ',
  navExecutionEnvironments: 'Окружения',
  search: 'Поиск…',
  noItems: 'Нет записей',
  noMatches: 'Ничего не найдено',
  rowsPerPage: 'Строк на странице',
  selectedN: 'Выбрано: {count}',
  deleteN: 'Удалить {count}',
  runN: 'Запустить {count}',
  activateN: 'Активировать {count}',
  deactivateN: 'Деактивировать {count}',
  bulkDeleteConfirm: 'Удалить выбранные записи ({count})? Действие необратимо.',

  // API tokens
  'New Token': 'Новый токен',
  'API Reference': 'Документация API',
  Cancel: 'Отмена',
  Create: 'Создать',
  Active: 'Активен',
  Expired: 'Истёк',
  Revoked: 'Отозван',
  Expires: 'Истекает',
  Never: 'Никогда',
  Custom: 'Свой',
  'Expiration date': 'Дата истечения',
  token: 'Токен',
  created: 'Создан',
  deleteToken: 'Удалить токен',
  askDeleteToken: 'Удалить этот API-токен? Любой клиент, использующий его, потеряет доступ.',
  nDays: '{count} дн.',
  oneYear: '1 год',
  exampleInventoryHosts: 'Пример: inventories/production/hosts',
  skipGalaxyPreflight: 'Пропустить Galaxy preflight',
  skipGalaxyPreflightHint: 'Отключить автоматическую установку ролей/коллекций через ansible-galaxy из requirements.yml перед запуском плейбука.',

  // Activity stream
  activityAction: 'Действие',
  activityObjectType: 'Тип объекта',
  activitySystemActor: 'Система',
  activityAction_create: 'Создано',
  activityAction_update: 'Обновлено',
  activityAction_delete: 'Удалено',
  activityAction_run: 'Запущено',
  activityObjectType_template: 'Шаблон',
  activityObjectType_inventory: 'Инвентарь',
  activityObjectType_environment: 'Группа переменных',
  activityObjectType_key: 'Ключ доступа',
  activityObjectType_repository: 'Репозиторий',
  activityObjectType_schedule: 'Расписание',
  activityObjectType_integration: 'Интеграция',
  activityObjectType_execution_environment: 'Окружение выполнения',
  activityObjectType_task: 'Задача',
  activityObjectType_project: 'Проект',
  activityObjectType_user: 'Пользователь',
  activityObjectType_view: 'Представление',
  eeRegistryCredential: 'Учётные данные registry (опционально)',
  eeRegistryCredentialHint: 'Используются для docker login перед pull. Нужны для приватных registry (GitLab CR, Harbor, …).',
  keyFormEnvVars: 'Переменные окружения',
  keyFormEnvVarsLabel: 'KEY=VALUE по одной на строку',
  keyFormEnvVarsHint: 'Строки, начинающиеся с #, игнорируются. Подходит для наборов кредов: AWS_ACCESS_KEY_ID + AWS_SECRET_ACCESS_KEY, VAULT_TOKEN и т.п.',

  // Workflows
  workflows: 'Сценарии',
  workflowNodes: 'Узлов',
  newWorkflow: 'Новый сценарий',
  editWorkflow: 'Редактировать сценарий',
  deleteWorkflow: 'Удалить сценарий',
  askDeleteWorkflow: 'Удалить этот сценарий? История запусков сохранится.',
  noWorkflowsYet: 'Сценариев пока нет',
  workflowDefinition: 'Определение (JSON: nodes + edges)',
  workflowDefinitionInvalid: 'Определение должно быть JSON-объектом с массивами `nodes` и `edges`',
  workflowFormDefinitionHelp: 'Сценарий — это граф шаблонов. Ребро задаёт, когда срабатывает целевой узел: on_success, on_failure или always. Выбери шаблон ниже, чтобы добавить узел, а связи отредактируй вручную.',
  workflowInsertNode: 'Добавить узел для шаблона…',
  workflowRunStarted: 'Запущен сценарий #{id}',

  // Execution Environment builds (ansible-builder)
  eeBuilds: 'Сборки EE',
  newEEBuild: 'Новая сборка EE',
  editEEBuild: 'Редактировать сборку EE',
  deleteEEBuild: 'Удалить сборку EE',
  askDeleteEEBuild: 'Удалить конфигурацию сборки? Уже запушенные образы останутся в registry.',
  noEEBuildsYet: 'Конфигураций сборки пока нет',
  eeBuildLastImage: 'Последний образ',
  eeBuildLastBuiltAt: 'Последняя сборка',
  eeBuildImagePrefix: 'Префикс образа',
  eeBuildImagePrefixHint: 'Полное имя образа без тега. Пример: registry.example.com/devops/my-ee',
  eeBuildImagePrefixRequired: 'Префикс образа обязателен',
  eeBuildRegistryUrl: 'URL registry (опционально)',
  eeBuildRegistryUrlHint: 'По умолчанию берётся хост из префикса. Используется для docker login, если заданы учётные данные.',
  eeBuildDefinition: 'Определение (execution-environment.yml)',
  eeBuildDefinitionHint: 'Содержимое файла, которое получает `ansible-builder build`.',
  eeBuildDefinitionRequired: 'Определение обязательно',
  eeBuildStarted: 'Сборка запущена — обнови список через секунду',
  eeBuildLog: 'Лог сборки',
  eeBuildNoLog: 'Лог ещё не записан',
  bulkRunConfirm: 'Запустить {count} шаблонов с параметрами по умолчанию?',
  bulkRunSkippedSurvey: 'Пропущено шаблонов с обязательными survey-переменными: {count}.',
  signInTitle: 'Вход',
  signInSubtitle: 'Используйте учётные данные ZetaPilot, чтобы продолжить.',
  twoStepVerification: 'Двухфакторная проверка',
  accountRecovery: 'Восстановление доступа',
  totpHint: 'Откройте приложение-аутентификатор, чтобы посмотреть текущий код.',
  emailOtpHint: 'Проверьте почту — мы только что отправили код подтверждения.',
  recoveryHint: 'Введите одноразовый код восстановления, чтобы вернуть доступ.',
  continue: 'Продолжить',
  or: 'или',
  projectStream: 'Поток проекта',
  noFlightsLogged: 'Полётов ещё не было',
  noTasksInProjectYet: 'В этом проекте ещё не запускались задачи.',
  dashboardSubtitle: 'Оперативное состояние проекта и последние запуски',
  dashboardUpdated: 'Обновлено:',
  dashboardRefresh: 'Обновить',
  dashboardOpenTemplates: 'Запустить задачу',
  dashboardMetricRunningNote: '{percent}% от последних запусков',
  dashboardMetricSuccessNote: '{percent}% от последних запусков',
  dashboardMetricFailedNote: '{percent}% от последних запусков',
  dashboardMetricQueuedNote: '{percent}% от последних запусков',
  dashboardMetricDefaultNote: '{percent}% от последних запусков',
  dashboardReadiness: 'Готовность среды',
  dashboardTaskStream: 'Поток задач',
  dashboardRecentRuns: 'Последние запуски',
  dashboardLastFailure: 'Последняя ошибка',
  dashboardLastSuccess: 'Последний успех',
  dashboardNoMessage: 'Сообщение не передано',
  dashboardNoFailures: 'Ошибок в последних запусках нет',
  dashboardNoSuccesses: 'Успешных запусков пока нет',
  dashboardTopTemplates: 'Топ шаблонов',
  dashboardRecentWindow: 'последние',
  dashboardNoTemplateRuns: 'Нет запусков шаблонов',
  dashboardSignals: 'Сигналы среды',
  dashboardSignalHistory: 'История',
  dashboardSignalActive: 'Активно',
  dashboardSignalQueue: 'Очередь',
  dashboardSignalSuccessRate: 'Успешность',
  dashboardSignalOperators: 'Операторы',
  dashboardSignalTemplates: 'Шаблоны',
  dashboardSignalFailures: 'Ошибки',
  dashboardSignalLatest: 'Последний ID',
  dashboardStatsSubtitle: 'Динамика запусков, статусы и нагрузка по операторам',
  dashboardActivitySubtitle: 'Аудит изменений проекта и действий операторов',
  dashboardSettingsSubtitle: 'Конфигурация проекта, сервисные действия и опасная зона',
  dashboardAuditTrail: 'Журнал аудита',
  statsTaskStatus: 'Статусы задач',
  testAlerts: 'Проверить оповещения',
  launchTask: 'Запуск задачи',
  templateId: 'ID шаблона',
  application: 'Приложение',
  launchReadiness: 'Готовность запуска',
  launchTabSetup: 'Подготовка',
  launchTabPrompts: 'Промпты',
  launchTabRuntime: 'Runtime',
  launchTabArguments: 'Аргументы',
  launchTabReview: 'Проверка',
  launchRunPlan: 'План запуска',
  launchExecutionTarget: 'Цель выполнения',
  launchOperatorInputs: 'Ввод оператора',
  launchRequiredPrompts: 'Обязательные промпты',
  launchOptionalPrompts: 'Необязательные промпты',
  launchPromptCount: '{count} полей',
  launchTemplateDefault: 'Из шаблона',
  launchNotSelected: 'Не выбрано',
  launchNotRequired: 'Не требуется',
  launchNoPrompts: 'Промптов нет',
  launchNoPromptsHint: 'Этот шаблон запускается без дополнительного ввода оператора.',
  launchRuntimeLocked: 'Runtime зафиксирован',
  launchRuntimeLockedHint: 'У этого приложения нет параметров запуска, доступных оператору.',
  launchArgumentsLocked: 'Аргументы закрыты',
  launchArgumentsLockedHint: 'Переопределение CLI-аргументов выключено в шаблоне.',
  statusOk: 'OK',
  statusFailed: 'Сбой',
  statusRunning: 'Выполняется',
  statusQueued: 'В очереди',
  statusStarting: 'Запуск',
  statusConfirmed: 'Подтверждено',
  statusRejected: 'Отклонено',
  statusStopping: 'Остановка',
  statusStopped: 'Остановлено',
  statusHold: 'Ожидание',
  pastWeek: 'За неделю',
  pastMonth: 'За месяц',
  pastYear: 'За год',
  allUsers: 'Все пользователи',
  allRunningTasksStopRequested: 'Все выполняющиеся задачи получили запрос на остановку',
  variableGroupSyncedSuccessfully: 'Группа переменных успешно синхронизирована',
  secretsSyncedSuccessfully: 'Секреты успешно синхронизированы',
  inventoryTypeStatic: 'Статический',
  inventoryTypeStaticYaml: 'Статический YAML',
  inventoryTypeFile: 'Файл',
  inventoryTypeDynamic: 'Динамический (плагин инвентаря)',
  tabLog: 'Лог',
  tabDetails: 'Детали',
  tabSummary: 'Сводка',
  taskRun: 'Запуск задачи',
  taskLogsStreaming: 'Логи идут',
  taskLogsConnected: 'Подключено к исполнителю через WebSocket',
  executionTimeline: 'Ход выполнения',
  runTelemetry: 'Телеметрия запуска',
  searchLogs: 'Поиск по логам...',
  allLevels: 'Все уровни',
  wrap: 'Перенос',
  pause: 'Пауза',
  resume: 'Продолжить',
  clear: 'Очистить',
  autoScrollOn: 'Автоскролл включен',
  stageQueued: 'Очередь',
  stageQueuedHint: 'Задача принята',
  stagePrepare: 'Подготовка',
  stagePrepareHint: 'Исполнитель и окружение',
  stageRun: 'Выполнение',
  stageFinish: 'Финиш',
  stageFinishHint: 'Ожидание завершения',
  stageFinishedHint: 'Запуск завершен',
  taskIdentity: 'Паспорт задачи',
  templateSource: 'Шаблон и источник',
  timing: 'Время',
  taskPayload: 'Payload задачи',
  taskParameters: 'Параметры задачи',
  items: 'элем.',
  stageAnalysis: 'Анализ стадий',
  stage: 'Стадия',
  hosts: 'Хосты',
  host: 'Хост',
  changed: 'Изменено',
  failed: 'Сбой',
  ignored: 'Игнор.',
  rescued: 'Rescued',
  skipped: 'Пропущено',
  unreachable: 'Недоступно',
  anomalies: 'Аномалии',
  noFailures: 'Без сбоев',
  allStagesCompleted: 'Все стадии завершены успешно.',
  allHosts: 'Все хосты',
  notOkHosts: 'Проблемные хосты',
  taskEvents: 'событий',
  recap: 'Итог',
  end: 'Окончание',
  reject: 'Отклонить',
  dontHaveAccountOrCantSignIn: 'Нет аккаунта или не можете войти?',
  password2: 'Пароль',
  cancel: 'Отмена',
  noViews: 'Нет представлений',
  addView: 'Добавить представление',
  editEnvironment: 'Редактировать группу переменных',
  deleteEnvironment: 'Удалить группу переменных',
  newEnvironment: 'Новая группа',
  environmentName: 'Имя группы',
  extraVariables: 'Дополнительные переменные',
  enterExtraVariablesJson: 'Введите дополнительные переменные в формате JSON...',
  environmentVariables: 'Переменные среды',
  enterEnvJson: 'Введите env JSON...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Переменные среды и дополнительные переменные должны быть действительным JSON. Пример:',
  dashboard2: 'Панель управления',
  ansibleSemaphore: 'ZetaPilot',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'Извините, но <%= htmlWebpackPlugin.options.title %> не работает должным образом без включенного JavaScript. Пожалуйста, включите его, чтобы продолжить.',
  deleteInventory: 'Удалить инвентарь',
  newInventory: 'Новый инвентарь',
  name: 'Имя',
  userCredentials: 'Учетные данные пользователя',
  userCredentialsOptional: 'Учетные данные пользователя (необязательно)',
  sudoCredentialsOptional: 'Учетные данные sudo (необязательно)',
  type: 'Тип',
  pathToInventoryFile: 'Путь к файлу инвентаря',
  enterInventory: 'Введите инвентарь...',
  staticInventoryExample: 'Пример статического инвентаря:',
  staticYamlInventoryExample: 'Пример статического YAML инвентаря:',
  dynamicInventoryHelp: 'Вставьте YAML-конфиг плагина инвентаря Ansible (например amazon.aws.aws_ec2). Соответствующая коллекция должна быть установлена в выбранном Execution Environment. Учётные данные провайдера передавайте через секреты Environment (env-переменные).',
  dynamicInventoryPlaceholder: 'plugin: amazon.aws.aws_ec2\nregions:\n  - eu-west-1\nkeyed_groups:\n  - key: tags.Role\n    prefix: role',
  dynamicInventoryRequiresEE: 'Динамические инвентари обычно требуют коллекций Ansible, которые поставляются в виде Execution Environment. Выберите его выше или задайте на сервере SEMAPHORE_ALLOW_DYNAMIC_INVENTORY_WITHOUT_EE=1, чтобы отключить эту проверку.',
  keyName: 'Имя ключа',
  loginOptional: 'Логин (необязательно)',
  usernameOptional: 'Имя пользователя (необязательно)',
  privateKey: 'Закрытый ключ',
  override: 'Переопределить',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Используйте этот тип ключа для HTTPS репозиториев и для плейбуков, которые используют не SSH соединения.',
  deleteKey: 'Удалить ключ',
  newKey: 'Новый ключ',
  create: 'Создать',
  newTask: 'Новая задача',
  cantDeleteThe: 'Невозможно удалить {objectTitle}',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: '{objectTitle} не может быть удален, так как он используется ресурсами ниже',
  projectName: 'Имя проекта',
  allowAlertsForThisProject: 'Разрешить оповещения для этого проекта',
  telegramChatIdOptional: 'Telegram Chat ID (необязательно)',
  maxNumberOfParallelTasksOptional: 'Максимальное количество параллельных задач (необязательно)',
  deleteRepository: 'Удалить репозиторий',
  newRepository: 'Новый репозиторий',
  urlOrPath: 'URL или путь',
  absPath: 'абс. путь',
  branch: 'Ветка',
  accessKey: 'Ключ доступа',
  testConnection: 'Проверить подключение',
  testConnectionOk: 'Подключение успешно',
  testConnectionSkipped: 'Пропущено — локальные/file репозитории не проверяются',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Учетные данные для доступа к Git репозиторию. Это должно быть:',
  ifYouUseGitOrSshUrl: 'если вы используете Git или SSH URL.',
  ifYouUseHttpsOrFileUrl: 'если вы используете HTTPS или file URL.',
  none: 'Нет',
  ssh: 'SSH',
  deleteProject: 'Удалить проект',
  save: 'Сохранить',
  deleteProject2: 'Удалить проект',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'После удаления проекта нет возврата. Пожалуйста, будьте уверены.',

  clear_cache: 'Очистить кэш',
  clear_cache_message: 'Удалить все файлы кэша, связанные с этим проектом. Это действие необратимо.',

  name2: 'Имя *',
  title: 'Название *',
  description: 'Описание',
  required: 'Обязательно',
  key: '{expr}',
  surveyVariables: 'Переменные опроса',
  addVariable: 'Добавить переменную',
  vaultName: 'ID хранилища (необязательно)',
  vaultNameDefault: 'Может существовать только одно имя `default` (пустое)',
  vaultNameUnique: 'Должно быть уникальным',
  vaultTypePassword: 'Пароль',
  vaultTypeScript: 'Клиентский скрипт',
  vaultScript: 'Путь к скрипту',
  vaultScriptRequired: 'Путь к скрипту обязателен',
  vaultScriptClientRequired: 'Путь к скрипту должен заканчиваться на \'-client\' и иметь расширение',
  vaults: 'Хранилища',
  vaultAdd: 'Добавить хранилище',
  vaultRequired: 'Пароль хранилища обязателен',
  columns: 'Столбцы',
  buildVersion: 'Версия сборки',
  messageOptional: 'Сообщение (необязательно)',
  debug: 'Отладка',
  dryRun: 'Пробный запуск',
  diff: 'Различия',
  advanced: 'Расширенные',
  hide: 'Скрыть',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Чтобы разрешить переопределение аргумента CLI в настройках шаблона задачи',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI аргументы (JSON массив). Пример: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Запущено',
  author: 'Автор',
  duration: 'Продолжительность',
  stop: 'Остановить',
  forceStop: 'Принудительная остановка',
  stopAll: 'Остановить все',
  stopAllTasks: 'Остановить все задачи',
  askStopAllTasks: 'Вы уверены, что хотите остановить все задачи?',
  forceStopAllTasks: 'Принудительно остановить все задачи',
  askForceStopAllTasks: 'Вы уверены, что хотите принудительно остановить все задачи?',
  raw_log: 'Сырой лог',

  confirmTask: 'Подтвердить',
  deleteTeamMember: 'Удалить участника команды',
  team2: 'Команда',
  newTeamMember: 'Новый участник команды',
  user: 'Пользователь',
  administrator: 'Администратор',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Определяет начальную версию вашего артефакта. Каждое выполнение увеличивает версию артефакта.',
  forMoreInformationAboutBuildingSeeThe: 'Для получения дополнительной информации о сборке смотрите',
  taskTemplateReference: 'Справка по шаблону задачи',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Определяет, какой артефакт должен быть развернут при выполнении задачи.',
  forMoreInformationAboutDeployingSeeThe: 'Для получения дополнительной информации о развертывании смотрите',
  taskTemplateReference2: 'Справка по шаблону задачи',
  definesAutorunSchedule: 'Определяет расписание автозапуска.',
  forMoreInformationAboutCronSeeThe: 'Для получения дополнительной информации о cron смотрите',
  cronExpressionFormatReference: 'Справка по формату выражений cron',
  startVersion: 'Начальная версия',
  example000: 'Пример: 0.0.0',
  buildTemplate: 'Шаблон сборки',
  autorun: 'Автозапуск',
  playbookFilename: 'Путь к файлу плейбука *',
  exampleSiteyml: 'Пример: deploy/site.yml',
  inventory2: 'Инвентарь *',
  repository: 'Репозиторий',
  environment3: 'Группа переменных *',
  vaultPassword: 'Пароль хранилища',
  vaultPassword2: 'Пароль хранилища',
  view: 'Представление',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Я хочу запускать задачу по cron только для новых коммитов некоторого репозитория',
  repository2: 'Репозиторий',
  cronChecksNewCommitBeforeRun: 'Cron проверяет новый коммит перед запуском',
  readThe: 'Читать',
  toLearnMoreAboutCron: 'чтобы узнать больше о Cron.',
  suppressSuccessAlerts: 'Подавить успешные оповещения',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI аргументы (JSON массив). Пример: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'CLI аргументы',
  docs: 'документация',
  editViews: 'Редактировать представления',
  newTemplate: 'Новый шаблон',
  taskTemplates2: 'Шаблоны задач',
  all: 'Все',
  notLaunched: 'Не запущено',
  by: 'от {user_name}',
  editTemplate: 'Редактировать шаблон',
  newTemplate2: 'Новый шаблон',
  deleteTemplate: 'Удалить шаблон',
  playbook: 'Плейбук',
  email: 'Электронная почта',
  adminUser: 'Администратор',
  sendAlerts: 'Отправить оповещения',
  deleteUser: 'Удалить пользователя',
  newUser: 'Новый пользователь',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} Участник команды',
  taskId: 'ID задачи',
  version: 'Версия',
  status: 'Статус',
  start: 'Начать',
  actions: 'Действия',
  alert: 'Оповещение',
  admin: 'Админ',
  role: 'Роль',
  external: 'Внешний',
  time: 'Время',
  path: 'Путь',
  gitUrl: 'Git URL',
  sshKey: 'SSH ключ',
  lastTask: 'Последняя задача',
  task2: 'Задача',
  build: 'Сборка',
  deploy: 'Развертывание',
  run: 'Запуск',
  add: 'Добавить',
  password_required: 'Пароль обязателен',
  name_required: 'Имя обязательно',
  user_credentials_required: 'Учетные данные пользователя обязательны',
  type_required: 'Тип обязателен',
  path_required: 'Путь к файлу инвентаря обязателен',
  private_key_required: 'Закрытый ключ обязателен',
  project_name_required: 'Имя проекта обязательно',
  repository_required: 'Репозиторий обязателен',
  branch_required: 'Ветка обязательна',
  key_required: 'Ключ обязателен',
  user_required: 'Пользователь обязателен',
  build_version_required: 'Версия сборки обязательна',
  title_required: 'Название обязательно',
  isRequired: 'обязательно',
  mustBeInteger: 'Должно быть целым числом',
  mustBe0OrGreater: 'Должно быть 0 или больше',
  start_version_required: 'Начальная версия обязательна',
  playbook_filename_required: 'Имя файла плейбука обязательно',
  inventory_required: 'Инвентарь обязателен',
  environment_required: 'Среда обязательна',
  email_required: 'Электронная почта обязательна',
  build_template_required: 'Шаблон сборки обязателен',
  Task: 'Задача',
  Build: 'Сборка',
  Deploy: 'Развертывание',
  Run: 'Запуск',
  ReBuild: 'Пересобрать',
  ReDeploy: 'Переразвернуть',
  ReRun: 'Повторный запуск',
  CreateDemoProject: 'Создать демонстрационный проект',
  LeaveProject: 'Покинуть проект',
  integration: 'Интеграция',
  integrations: 'Интеграции',
  NewIntegration: 'Новая интеграция',
  EditIntegration: 'Редактировать интеграцию',
  DeleteIntegration: 'Удалить интеграцию',
  DeleteIntegrationMsg: 'Вы уверены, что хотите удалить эту интеграцию?',
  AddAlias: 'Добавить псевдоним',
  LoadAlias: 'Загрузка псевдонимов...',
  globalAlias: 'Использовать псевдоним проекта',
  matcher: 'Сравнитель',
  matchType: 'Тип совпадения',
  newMatcher: 'Новый сравнитель',
  matchMethod: 'Метод сравнения',
  matchBodyDataType: 'Тип данных тела',
  extractValue: 'Извлечь значение',
  newExtractedValue: 'Новое извлеченное значение',
  extractedValueSource: 'Источник значения',
  matchKey: 'Ключ',
  matchValue: 'Значение',
  matchOn: 'Совпадение по',
  runners: 'Исполнители',
  newRunner: 'Новый исполнитель',
  enabled: 'Включено',
  scheduleNextRun: 'Следующий запуск',
  maxNumberOfParallelTasks: 'Максимальное количество параллельных задач',
  runnerUsage: 'Использование:',
  runnerDockerCommand: 'Docker:',
  runnerToken: 'Токен:',
  editRunner: 'Редактировать исполнителя',
  deleteRunner: 'Удалить исполнителя',
  newRunnerToken: 'Новый токен исполнителя',
  askDeleteRunner: 'Вы действительно хотите удалить исполнителя {runner}?',
  project_runners_only_pro: 'Исполнители на уровне проекта доступны только в версии <b>PRO</b>.',
  foss_runners_limited: 'Открытая версия имеет ограниченный функционал; полный функционал доступен в версии <b>PRO</b>.',
  learn_more_about_pro: 'Узнать больше',

  projectRestoreResult: 'Результаты восстановления проекта',
  projectWithNameRestored: 'Проект {projectName} успешно восстановлен.',
  pleaseUpdateAccessKeys: 'Пожалуйста, обновите их перед запуском задач.',
  emptyKeysRestored: '{emptyKeys} пустых ключей добавлено.',
  template: 'Шаблон',
  aliasUrlCopied: 'URL псевдонима скопирован в буфер обмена.',
  yes: 'Да',
  no: 'Нет',
  activeTasks: 'Активные задачи',
  taskLocation: 'Местоположение',
  empty: 'Пусто',
  noValues: 'Нет значений',
  addArg: 'Добавить аргумент',

  status_success: 'Успех',
  status_failed: 'Неудача',
  status_stopped: 'Остановлено',

  api_tokens: 'API токены',

  // Terraform/OpenTofu
  auto_approve: 'Авто одобрение',

  // Ansible
  tag: 'Тег',
  tag_required: 'Тег обязателен',
  allowInventoryInTask: 'Инвентарь',
  allowLimitInTask: 'Лимит',
  addLimit: 'Добавить лимит',
  allowDebug: 'Отладка',
  addTag: 'Добавить тег',
  skipTags: 'Пропустить теги',
  addSkippedTag: 'Добавить пропущенный тег',
  tags: 'Теги',
  limit: 'Лимит',

  runner_tag: 'Тег исполнителя',
  task_prompts: 'Подсказки',
  ready: 'Готово',
  templateComposerModule: 'Модуль',
  templateComposerSections: 'Разделы шаблона',
  templateComposerStep: 'Шаг',
  templateComposerIdentity: 'Основное',
  templateComposerSource: 'Источник',
  templateComposerRuntime: 'Контроль запуска',
  templateComposerLaunchPolicy: 'Политика запуска',
  templateComposerReview: 'Проверка',
  templateComposerFileHint: 'Подсказки появятся после выбора репозитория; ручной ввод разрешен.',
  templateComposerCliArgs: 'CLI аргументы',
  templateComposerCommand: 'Предпросмотр команды',
  templateComposerReadiness: 'Готовность',
  templateComposerResources: 'Ресурсы',
  templateComposerCapabilities: 'Контроль оператора',
  templateComposerAutomation: 'Автоматизация',
  templateComposerRiskHints: 'Риски',
  templateComposerDefaultBranch: 'ветка по умолчанию',
  templateComposerNoRepository: 'Репозиторий не выбран',
  templateComposerParallel: 'параллельно',
  templateComposerDefaultRuntime: 'запуск по умолчанию',
  templateComposerManualOnly: 'только вручную',
  templateComposerAnyRunner: 'любой исполнитель',
  templateComposerSurveyCount: '{count} переменных',
  templateComposerPromptCount: '{enabled}/{total} включено',
  templateComposerPromptNote: 'Включенные элементы становятся решениями оператора или расписания при запуске.',
  templateComposerPromptArgsDescription: 'Разрешить свои аргументы командной строки перед запуском.',
  templateComposerPromptBranchDescription: 'Разрешить запуск другой SCM ветки или ref.',
  templateComposerPromptInventoryDescription: 'Разрешить менять инвентарь или workspace.',
  templateComposerPromptLimitDescription: 'Разрешить менять Ansible limit.',
  templateComposerPromptTagsDescription: 'Разрешить выбирать Ansible теги при запуске.',
  templateComposerPromptSkipTagsDescription: 'Разрешить исключать Ansible теги при запуске.',
  templateComposerPromptDebugDescription: 'Показывать управление verbosity при запуске задачи.',
  templateComposerPromptAutoApproveDescription: 'Разрешить auto approve для IaC запусков.',
  templateComposerEntrypointPlaceholder: '<точка входа>',
  templateComposerCheckName: 'У шаблона есть имя',
  templateComposerCheckStartVersion: 'Начальная версия задана',
  templateComposerCheckBuildTemplate: 'Шаблон сборки выбран',
  templateComposerCheckRepository: 'Репозиторий выбран',
  templateComposerCheckEntrypoint: 'Точка входа задана',
  templateComposerCheckInventory: 'Инвентарь/workspace выбран',
  templateComposerCheckEnvironment: 'Среда выбрана',
  templateComposerCheckCronRepository: 'Репозиторий для cron выбран',
  templateComposerSchedule: 'Расписание',
  templateComposerPreflightRepository: 'Checkout репозитория',
  templateComposerPreflightRepositoryMissing: 'Выберите репозиторий перед запуском.',
  templateComposerPreflightEntrypoint: 'Точка входа',
  templateComposerPreflightEntrypointMissing: 'Задайте путь к плейбуку или скрипту.',
  templateComposerPreflightEntrypointMatched: 'Файл найден среди подсказок репозитория.',
  templateComposerPreflightEntrypointManual: 'Ручной путь будет использован как введен.',
  templateComposerPreflightInventory: 'Цели',
  templateComposerPreflightInventoryMissing: 'Выберите инвентарь или workspace.',
  templateComposerPreflightSchedule: 'Ограничение расписания',
  templateComposerPreflightScheduleEnabled: 'Cron будет проверять выбранный репозиторий.',
  templateComposerPreflightOperatorControls: 'Контроль оператора',
  templateComposerRiskArgs: 'Операторы смогут переопределять CLI аргументы при запуске.',
  templateComposerRiskInventory: 'Операторы смогут менять инвентарь/workspace при запуске.',
  templateComposerRiskParallel: 'Параллельные запуски могут пересекаться на одних целях.',
  template_advanced: 'Расширенные параметры',
  template_app_options: '{app} параметры',
  template_app_prompts: '{app} подсказки',
  general_settings: 'Общие',
  danger_zone_settings: 'Опасная зона',
  project_stats: 'Статистика',
  allow_override_branch: 'Ветка',
  template_common_options: 'Общие параметры',

  // Execution Environments (EE)
  executionEnvironment: 'Окружения выполнения',
  executionEnvironmentSingular: 'Окружение выполнения',
  newExecutionEnvironment: 'Новое окружение выполнения',
  editExecutionEnvironment: 'Редактировать окружение выполнения',
  deleteExecutionEnvironment: 'Удалить окружение выполнения',
  askDeleteEE: 'Действительно удалить это окружение выполнения?',
  eeImage: 'Образ контейнера',
  eeImagePlaceholder: 'quay.io/ansible/awx-ee:latest',
  eeImageRequired: 'Образ обязателен',
  eePullPolicy: 'Политика загрузки образа',
  eeHint: 'Если выбрано в шаблоне, ansible-playbook запускается внутри указанного контейнера. На хосте раннера должен быть установлен Docker.',

  // Roles
  Roles: 'Роли',
  newRole: 'Новая роль',
  editRole: 'Редактировать роль',
  deleteRole: 'Удалить роль',
  askDeleteRole: 'Действительно удалить эту роль?',
  role_required: 'Роль обязательна',
  roles_only_enterprise: 'Роли доступны только в Enterprise-версии',
  slug: 'Идентификатор (slug)',
  slug_required: 'Slug обязателен',
  invalidSlugFormat: 'Неверный формат slug',
  slugHint: 'Уникальный идентификатор только из латинских букв в нижнем регистре, цифр и дефисов',
  permissions: 'Права',
  templatePermission: 'Права на шаблон',
  canManageProjectResources: 'Управление ресурсами проекта',
  canManageProjectUsers: 'Управление пользователями проекта',
  canRunProjectTasks: 'Запуск задач проекта',
  canUpdateProject: 'Изменение настроек проекта',

  // System / Settings
  system: 'Система',
  systemInfo: 'Информация о системе',
  authentication: 'Аутентификация',
  passwordLogin: 'Вход по паролю',
  oidcProviders: 'Провайдеры OIDC',
  emailOtp: 'Одноразовый код по email',
  notifications: 'Уведомления',
  taskSettings: 'Настройки задач',
  featureFlags: 'Флаги функций',
  highAvailability: 'Высокая доступность',
  uiInstances: 'Экземпляры UI',
  nodeCount: 'Кол-во узлов',
  nodeId: 'ID узла',
  cluster: 'Кластер',
  database: 'База данных',
  dbDialect: 'Диалект СУБД',
  tmpPath: 'Временный каталог',
  gitClient: 'Git-клиент',
  homeDirMode: 'Режим домашнего каталога',
  scheduleTimezone: 'Часовой пояс расписаний',
  useRemoteRunner: 'Использовать удалённый раннер',
  globalRunners: 'Глобальные раннеры',
  maxParallelTasks: 'Макс. параллельных задач',
  maxTasksPerTemplate: 'Макс. задач на шаблон',
  maxTaskDuration: 'Макс. длительность задачи',
  nonAdminCanCreateProject: 'Не-админ может создавать проекты',
  goVersion: 'Версия Go',
  tokenName: 'Имя токена',
  unlimited: 'Не ограничено',
  default: 'По умолчанию',
  default_value: 'Значение по умолчанию',
  global: 'Глобально',
  project: 'Проект',
  active2: 'Активно',
  synchronized: 'Синхронизировано',
  ansibleNotFound: 'Ansible не найден',
  environmentsHint: 'Все настроенные группы переменных сливаются по приоритету: значения справа перекрывают левые',
  dockerImage: 'Docker-образ раннера (необязательно)',
  allow_parallel_tasks: 'Разрешить параллельные запуски',
  auto_destroy: 'Авто-удаление',
  template_details: 'Детали шаблона',
  template_tasks: 'Задачи шаблона',
  template_tf_workspaces: 'Workspaces',
  terraform_backend_filename: 'Имя файла backend',
  terraform_override_backend: 'Переопределить backend',
  terraform_invalid_backend_filename: 'Неверное имя файла backend',
  upgrade_to_pro: 'Обновитесь до Pro',
  secret_storage_only_pro: 'Хранилище секретов доступно только в Pro',
  contact_admin_to_upgrade: 'Свяжитесь с администратором для обновления',
  contact_admin_to_upgrade_enterprise: 'Свяжитесь с администратором для перехода на Enterprise',
  viewNames: {
    all: 'Все',
    build: 'Сборка',
    deploy: 'Деплой',
    tools: 'Инструменты',
    task: 'Задача',
    tasks: 'Задачи',
    default: 'По умолчанию',
    main: 'Основное',
    other: 'Прочее',
  },
  theme_system: 'Система',
  theme_light: 'Светлая',
  theme_dark: 'Тёмная',
  showPassword: 'Показать пароль',
  hidePassword: 'Скрыть пароль',
  helpTooltip: 'Справка',
  copy_to_clipboard: 'Копировать в буфер обмена',
};
